import React from 'react';

export default props => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="12.289" height="1.516" viewBox="0 0 12.289 1.516">
            <path id="Path_235" data-name="Path 235" d="M-2.633-4.57a.731.731,0,0,0,.371-.1.755.755,0,0,0,.277-.273.738.738,0,0,0,.1-.383.724.724,0,0,0-.1-.375.786.786,0,0,0-.277-.277.71.71,0,0,0-.371-.105H-13.414a.684.684,0,0,0-.371.105.881.881,0,0,0-.277.277.685.685,0,0,0-.109.375.7.7,0,0,0,.109.383.843.843,0,0,0,.277.273.7.7,0,0,0,.371.1Z" transform="translate(14.172 6.086)"/>
        </svg>
    );
}